import { useSelector } from 'react-redux';
import setPath from '@/lib/setPath.js';
import { IoWarning } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2.jsx';
import routes from '@/routes.js';
import useBillingCycle from '@/hooks/useBillingCycle.js';

const PlatformOperationBanner = () => {
  const hasPublishedWorkflows = useSelector((state) => state.settings?.companyLimits?.hasPublishedWorkflows);
  const activeRouteId = useSelector((state) => state.ui.activeRouteId);
  const activeRoute = routes.find((n) => n.id === activeRouteId);
  const { hasReachedLimit } = useBillingCycle();
  const show = hasPublishedWorkflows && hasReachedLimit;

  const handleClick = () => {
    setPath('/user/billing');
  };

  if (!show) {
    return null;
  }

  return (
    <div className={`platform-operation-banner route-${activeRoute?.routeId}`}>
      <IconV2 icon={IoWarning} />
      <p>
        You have exceeded your allowed task limit for this 30-day rolling window. <a onClick={handleClick}>Upgrade your plan</a>
      </p>
    </div>
  );
};

export default PlatformOperationBanner;
